import { render, staticRenderFns } from "./BookingDetailPcp.vue?vue&type=template&id=c00dd7ba&scoped=true"
import script from "./BookingDetailPcp.vue?vue&type=script&lang=js"
export * from "./BookingDetailPcp.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailPcp.vue?vue&type=style&index=0&id=c00dd7ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00dd7ba",
  null
  
)

export default component.exports